<section
  id="news"
  class="py-5 bg-light"
  aria-label="Notícias sobre clima e agricultura"
  >
  <div class="container">
    <h2 class="mb-4 text-center fw-bold">Notícias e Atualizações</h2>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando notícias...</span>
        </div>
        <p class="mt-3 text-muted">Carregando notícias...</p>
      </div>
    }

    <!-- Error Message (quando há erro E sem notícias) -->
    @if (!isLoading && errorMessage && newsLinks.length === 0) {
      <div
        class="row justify-content-center"
        >
        <div class="col-12 col-md-8 col-lg-6">
          <div
            class="alert text-center"
            [ngClass]="isServerError ? 'alert-danger' : 'alert-info'"
            role="alert"
            >
            <i
              class="fa-solid me-2"
            [ngClass]="
              isServerError ? 'fa-exclamation-triangle' : 'fa-info-circle'
            "
            ></i>
            {{ errorMessage }}
          </div>
        </div>
      </div>
    }

    <!-- News Grid -->
    @if (!isLoading && newsLinks.length > 0) {
      <div class="row g-4">
        @for (newsLink of newsLinks; track newsLink) {
          <div
            class="col-md-6 col-lg-4"
            [attr.data-news-id]="newsLink.id"
            >
            <app-news-card
              [icon]="getIconForType(newsLink.type)"
              [title]="newsLink.title"
              [date]="getFormattedDate(newsLink.creationDate)"
              [description]="getDescription(newsLink.description)"
              [url]="newsLink.url"
            ></app-news-card>
          </div>
        }
      </div>
    }
  </div>
</section>
